<template>
    <div class="hservice">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h4 class="title1">高频次触达学员家长 家校服务数据化</h4>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item1_list">
                        <img :src='"/static/img/product_hservice/chanpin4_0"+(index+1)+".png"' alt="">
                        <div class="title">{{x.title}}</div>
                        <div class="content">{{x.value}}</div>
                    </li>
                </ul>
                <!-- <ul style="margin-top: 30px;">
                    <li v-for="(x,index) in item2_list">
                        <img :src='"/static/img/product_hservice/chanpin4_0"+(index+1)+".png"' alt="">
                        <div class="title">{{x.title}}</div>
                        <div class="content">{{x.value}}</div>
                    </li>
                </ul> -->
            </div>
        </div>

        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing,
    },
    data(){
        return{
            item1_list: [
                { title: "消息通知", value: "学员到校离校通知、上课提醒、续费提醒等，一键触达家长，重要信息不错过"},
                { title: "作业提交", value: "学员可在线提交作业，系统自动提醒未提交学员，提高学员作业积极性" },
                { title: "互动点评", value: "老师与家长可对学员上课表现、作业进行互动点评，提高家长参与度"},
                { title: "精彩分享", value: "家长可实时查看学员课堂表现，并可将精彩表现分享至朋友圈" },
                {title:"多人查看",value:"支持多名家庭成员登陆家长端，实时查看学员在校表现"},
                {title:"自主约课",value:"家长可通过手机端在线自助查看机构课程信息并约课，提高机构课程预约率"},
                {title:"学员档案",value:"建立学员成长档案，通过视频、图片等全方位记录学员成长轨迹，家长随时查看"},
                {title:"在线缴费",value:"机构可将学员缴费订单信息推送至家长手机，家长在线缴费，轻松便捷"},
            ],
            item2_list: [
            ],
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
                    this.$parent.$refs.openPop.openDialog(title,type);
                }
    }
}
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 480px;
    margin-top: 80px;
    background: url("https://cdntest.yizhiniao.com/newWebsite_/product_hservice/chanpin4_banner.jpg") no-repeat center;

    .banner-center {
        height: 100%;
        position: relative;
    }

    .banner-info {
        position: absolute;
        bottom: 120px;
        left:50px;
        text-align: left;
    }
    .shenqing{
        border: none;
        color:#fff;
        background: linear-gradient(174deg, #FF7583 0%, #FFD6AB 100%);
        border-radius: 4px;
        &:hover,&:active{
            background: linear-gradient(174deg, #FF7583 0%, #FFD6AB 100%);
            color:#fff;
        }
    }
}

.item_1 {
        padding-top:160px;
        padding-bottom: 160px;
        .item-contents {
            margin-top: 60px;

            ul {
                width: 1130px;
                height: 590px;
                margin:0 auto;
                padding-top: 20px;
                padding-bottom: 20px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content: space-between;
                li {
                    width: 260px;
                    height: 260px;
                    padding: 10px 20px 20px;
                    background: #F9FCFF;
                    border: 1px solid rgba(89, 112, 196, 0.2);

                    img {
                        width: 100px;
                        height: 100px;
                        margin: 0 auto 10px;
                    }

                    .title {
                        text-align: center;
                        color: #4A4A4A;
                        font-size: 20px;
                    }

                    .content {
                        width: 220px;
                        margin: 10px auto 0;
                        color: #9B9B9B;
                        font-size: 14px;
                        text-align: left;
                        line-height: 20px;
                    }

                    &:hover {
                        transition: 0.5s;
                        margin-top: -10px;
                        background: #FFFFFF;
                        border:none;
                        box-shadow: 0px 2px 30px 0px rgba(191, 202, 214, 0.5);
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/product_hservice.vue